<div class="card">
    <h4>Choose a logo</h4>
    <p-fileUpload
        #logoUploader
        name="logo"
        url="./upload.php"
        customUpload="true"
        (onSelect)="onLogoSelect($event)"
        (uploadHandler)="uploadLogo($event)"
        multiple="multiple"
        accept="image/*"
        maxFileSize="1000000"
    >
        <ng-template pTemplate="content">
            <ul *ngIf="uploadedFiles.length">
                <li *ngFor="let file of uploadedFiles">
                    {{ file.name }} - {{ file.size }} bytes
                </li>
            </ul>
        </ng-template>
    </p-fileUpload>
    <p-message
        *ngIf="showUploadComplete == true"
        severity="success"
        [text]="uploadCompleteMsg"
    ></p-message>

    <div *ngIf="this.selectedLogo" style="margin-top: 3em">
        <h4>Current Logo</h4>
        <img
            [src]="this.selectedLogo"
            style="max-width: 500px; max-height: 500px"
        />
    </div>
</div>
